import settings from '@/config/settings';

import type {IUser, IUserAll, IUserBody, IUserUpdate} from '@/api/types/user';

import useAPIHook from '@/assets/core/assets/hooks/APIHook';

import type {IQueryObject} from '@/assets/core/assets/helpers/serialize';

const url = new URL(settings.SERVICES.BACKEND.URL + '/user');

export const userAPI = useAPIHook<
  IUser,
  IUserAll,
  unknown,
  IUserBody | IUserUpdate,
  IQueryObject
>(url);
